import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { ApiModule } from './rest';
import { SharedModule } from './shared/shared.module';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { TextInputAutocompleteModule } from 'angular-text-input-autocomplete';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { GlobalLanguageEventService } from 'src/app/shared/_services/global-language-event.service';
import { LoadingPagesService } from './shared/_services/loading-pages.service';

import { ArticlesModule } from './back-office/articles/articles.module';
import { PagesModule } from './back-office/pages/pages.module';
import { ErrorModule } from './error/error.module';
import { FrontOfficeModule } from './front-office/front-office.module';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
/*export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}*/

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${new Date().getTime()}`);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ApiModule,
    FontAwesomeModule,
    ToastrModule.forRoot(),
    SharedModule,
    LayoutModule,
    IvyCarouselModule,
    TextInputAutocompleteModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    TextInputAutocompleteModule,
    ArticlesModule,
    PagesModule,
    ErrorModule,
    FrontOfficeModule
  ],
  providers: [
    GlobalLanguageEventService,
    LoadingPagesService,
    { provide: 'googleTagManagerId', useValue: 'GTM-NR89LCX' },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
